class S71AgeGate extends HTMLElement {
  constructor() {
    super();
    this.gate = this.querySelector('[data-s71-age-gate]');
    this.error = this.querySelector('[data-s71-age-error]');
    this.yes = this.querySelector('[data-s71-age-yes]');
    this.no = this.querySelector('[data-s71-age-no]');
    this.key = this.dataset.key || 's71-age-gate';
    this.days = Number(this.dataset.days || 30);
    this.onKeyDown = this.onKeyDown.bind(this);
  }

  connectedCallback() {
    if (!this.gate) return;

    this.yes?.addEventListener('click', () => this.confirm());
    this.no?.addEventListener('click', () => this.decline());

    if (this.gate.hidden) return;

    document.body.classList.add('s71-scroll-locked');
    document.addEventListener('keydown', this.onKeyDown);

    if (typeof trapFocus === 'function') trapFocus(this.gate, this.gate);
    else this.gate.focus();
  }

  disconnectedCallback() {
    document.removeEventListener('keydown', this.onKeyDown);
  }

  onKeyDown(event) {
    if (event.key !== 'Tab' || this.gate.hidden) return;
    if (this.gate.contains(event.target)) return;

    event.preventDefault();
    this.gate.focus();
  }

  store() {
    const value = this.days > 0 ? String(Date.now() + this.days * 86400000) : 'session';

    try {
      if (this.days > 0) localStorage.setItem(this.key, value);
      else sessionStorage.setItem(this.key, value);
    } catch (error) {
      this.remembered = value;
    }
  }

  confirm() {
    this.store();
    this.gate.hidden = true;
    document.body.classList.remove('s71-scroll-locked');
    document.removeEventListener('keydown', this.onKeyDown);

    if (typeof removeTrapFocus === 'function') removeTrapFocus();
  }

  decline() {
    if (!this.error) return;

    this.error.hidden = false;
    this.error.setAttribute('role', 'alert');
  }
}

if (!customElements.get('s71-age-gate')) {
  customElements.define('s71-age-gate', S71AgeGate);
}
